module.exports = __webpack_public_path__ + "img/2025-12-20b_2.e5d5b6b7.jpg";